import React from 'react';
import SegmentedToggle from './SegmentedToggle';
const GROUP_BY_OPTIONS = [
    { value: 'course', label: 'By Course' },
    { value: 'stroke', label: 'By Stroke' },
];
const GroupByToggle = ({ value, onChange, disabled }) => (React.createElement("div", { className: "filter-chip-group" },
    React.createElement(SegmentedToggle, { options: GROUP_BY_OPTIONS, value: value, onChange: onChange, disabled: disabled })));
export default GroupByToggle;
